var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5339 12.0443C10.8333 12.7449 10.8333 13.8808 11.5339 14.5814L17.4564 20.5039L11.5339 26.4264C10.8333 27.127 10.8333 28.2629 11.5339 28.9635C12.2345 29.6641 13.3704 29.6641 14.071 28.9635L19.9935 23.041L25.9108 28.9583C26.6114 29.6589 27.7473 29.6589 28.4479 28.9583C29.1485 28.2577 29.1485 27.1218 28.4479 26.4212L22.5306 20.5039L28.4479 14.5866C29.1485 13.886 29.1485 12.7501 28.4479 12.0495C27.7473 11.3489 26.6114 11.3489 25.9108 12.0495L19.9935 17.9668L14.071 12.0443C13.3704 11.3437 12.2345 11.3437 11.5339 12.0443Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.a19ec85f96a95fad6bb2dcc23c29561f.svg";
export { ForwardRef as ReactComponent };